import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

// Handles the #session_id=... fragment returned by Emergent Auth
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate('/admin/login'); return; }
      try {
        const { data } = await api.post('/auth/session', { session_id: sessionId });
        setUser(data);
        // clear the hash and go to dashboard
        window.history.replaceState(null, '', '/admin');
        navigate('/admin', { state: { user: data } });
      } catch (e) {
        navigate('/admin/login', { state: { error: 'Login failed. Please try again.' } });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[70vh] grid place-items-center bg-ktc-ivory">
      <div className="text-center">
        <Loader2 className="mx-auto animate-spin text-ktc-green" size={40} />
        <p className="text-ktc-charcoal/70 mt-4 font-sans">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
